var exports = {
  "Ve": "ThemeTab.module__themeButtonGroup___aGpTRE",
  "mB": "ThemeTab.module__themeButton___aGpTRE",
  "RL": "ThemeTab.module__themeButtonSelected___aGpTRE",
  "Uk": "ThemeTab.module__themeButtonLight___aGpTRE",
  "sy": "ThemeTab.module__themeButtonDark___aGpTRE",
  "H2": "ThemeTab.module__themeButtonIcon___aGpTRE",
  "zO": "ThemeTab.module__themeButtonCheckmark___aGpTRE",
  "Qs": "ThemeTab.module__themeButtonCheckmarkIcon___aGpTRE",
};

module.exports = exports;
